import React from 'react';
interface IconProps {
  size?: number;
  className?: string;
}
export function StethoscopeIcon({
  size = 24,
  className = ''
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-273">
      <path d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3" data-id="element-274" />
      <path d="M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4" data-id="element-275" />
      <circle cx="20" cy="10" r="2" data-id="element-276" />
    </svg>;
}
export function PipeWrenchIcon({
  size = 24,
  className = ''
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-277">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" data-id="element-278" />
    </svg>;
}
export function MoneyBleedIcon({
  size = 24,
  className = ''
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-279">
      <line x1="12" y1="1" x2="12" y2="23" data-id="element-280" />
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" data-id="element-281" />
      <path d="M16 16v6a2 2 0 0 1-2 2h-4" strokeDasharray="2 4" data-id="element-282" />
      <path d="M12 21.5c-1.5 0-2.5-1-2.5-2.5s2.5-4.5 2.5-4.5 2.5 3 2.5 4.5-1 2.5-2.5 2.5z" fill="currentColor" data-id="element-283" />
    </svg>;
}
export function PriceTagIcon({
  size = 24,
  className = ''
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-284">
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" data-id="element-285" />
      <line x1="7" y1="7" x2="7.01" y2="7" data-id="element-286" />
      <path d="M12 12l4 4m0-4l-4 4" strokeWidth="2" data-id="element-287" />
    </svg>;
}
export function MobileLandingIcon({
  size = 24,
  className = ''
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-288">
      <rect x="5" y="2" width="14" height="20" rx="2" ry="2" data-id="element-289" />
      <path d="M12 18h.01" data-id="element-290" />
      <path d="M15 9l-3 3-1.5-1.5" data-id="element-291" />
      <path d="M16 14a4 4 0 0 1-8 0" strokeDasharray="2 4" data-id="element-292" />
    </svg>;
}
export function TargetAdsIcon({
  size = 24,
  className = ''
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-293">
      <circle cx="12" cy="12" r="10" data-id="element-294" />
      <circle cx="12" cy="12" r="6" data-id="element-295" />
      <circle cx="12" cy="12" r="2" data-id="element-296" />
      <line x1="12" y1="2" x2="12" y2="6" data-id="element-297" />
      <line x1="12" y1="18" x2="12" y2="22" data-id="element-298" />
      <line x1="2" y1="12" x2="6" y2="12" data-id="element-299" />
      <line x1="18" y1="12" x2="22" y2="12" data-id="element-300" />
    </svg>;
}
export function WaterDropIcon({
  size = 24,
  className = ''
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-301">
      <path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z" data-id="element-302" />
    </svg>;
}
export function PhoneRingIcon({
  size = 24,
  className = ''
}: IconProps) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-303">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" data-id="element-304" />
      <path d="M14.05 2a9 9 0 0 1 8 7.94" data-id="element-305" />
      <path d="M14.05 6A5 5 0 0 1 18 10" data-id="element-306" />
    </svg>;
}